// This example shows you how to set up React Stripe.js and use Elements.
// Learn how to accept a payment using the official Stripe docs.
// https://www.stripe.com/docs/payments/integration-builder

import React from "react";

import "../css/global.css";

import logo from "../assets/logo.png";
import info1 from "../assets/info1.png";
import info2 from "../assets/info2.png";
import info3 from "../assets/info3.png";
import info4 from "../assets/info4.png";

const Info = () => {
  return (
    <>
      <img className="logo" src={logo} alt="logo" />
      <h1 className="title">Καλωσήλθατε στο LAVORIA</h1>
      <div className="description">
        Αντιστοιχίζει άψογα τον εργοδότη με τον κατάλληλο εργαζόμενο στον κλάδο
        HoReCa
      </div>
      <section className="infoSection">
        <div className="infoSection-item">
          <img src={info1} alt="info" />
          <p className="infoSection-text">
            Πραγματοποιήστε αναζήτηση με έξυπνα φίλτρα, λάβετε σχετικά προφίλ
          </p>
        </div>
        <div className="infoSection-item">
          <img src={info2} alt="info" />
          <p className="infoSection-text">
            Δημοσιεύστε νέες θέσεις εργασίας σε λεπτά
          </p>
        </div>
        <div className="infoSection-item">
          <img src={info3} alt="info" />
          <p className="infoSection-text">
            Συνεργαστείτε με την ομάδα σας στη διαδικασία προσλήψεων
          </p>
        </div>
        <div className="infoSection-item">
          <img src={info4} alt="info" />
          <p className="infoSection-text">Κλήσεις και συνομιλίες με τον υποψήφιο</p>
        </div>
      </section>
    </>
  );
};

export default Info;
